import * as util from 'util';
import _ from 'lodash';
import {eachLimit} from 'async';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {AuthService} from "../../../../services/authService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";

@Component({
	selector: 'inbound-mailboxes-component',
	templateUrl: './inbound-mailboxes.component.html',
})
export class InboundMailboxesComponent implements OnInit {
	constructor(private router:Router,
				public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private authService:AuthService) {
    }

    dic = DICTIONARY;
	_=_;
	// TODO: temporary gate (EMDR security reviewer or this plan only). Remove subscriptionBombingPlanId and the is_security_reviewer/plan_id conditions (html + actions) to enable Subscription Bombing Protection for all clients
	subscriptionBombingPlanId = '622a76247142df0004ef7646';
	isLoaded = false;
    groups = [];
    subscriptionUsers = [];
    mailboxListView = this.dic.CONSTANTS.mailboxListViews.all;
    protectedUsersCount = 0;
    mailServerConnected;
    graphConnected;
    gsuiteConnected;
    filterData;
    userInfo;
    planInfo;
    smtpConnected;
    threatProtectionAllowedUsers;
    threatProtectionEnabled;
    subscriptionUsersNotificationIdx;
    loadingInProcess;
    mailboxesSubscriptions;
    activeMailboxList;

	mailboxAliasPopup
	changeUserSettingsPopup;

    createSubscriptionInProcess;
    showProtectGroups;
	showEnableApiProtectionPopup;
	inviteUserPopup;
    mailboxIndexInProcess;
    showGroups;
    showAliases;
	mailboxesFile;
	doNotChangeIsExpandedStates;

	ngOnInit() {
        this.mailServerConnected = false;
        this.graphConnected = false;
        this.gsuiteConnected = false;
        this.gs.getUserInfo(false, userInfo => {
            this.userInfo = userInfo;
        });

        this.rs.getInboundPlanSettings().then((planInfo) => {
            this.planInfo = planInfo;

			this.initFilters();

			if (planInfo.exchange_server?.tid && planInfo.exchange_server?.enabled) {
                this.mailServerConnected = true;
                this.graphConnected = true;
            }
            else if (planInfo.gsuite_server?.enabled) {
                this.gsuiteConnected = true;
                this.mailServerConnected = true;
            }

            if (this.planInfo.inbound_relay &&
                (this.planInfo.inbound_relay.enabled || this.planInfo.inbound_relay.sending_architecture === this.dic.CONSTANTS.inboundSendingArchitecture.mx)) {
                this.mailServerConnected = true;
                this.smtpConnected = true;
            }

            this.threatProtectionAllowedUsers = 0;
            this.threatProtectionEnabled = planInfo.threat_protection.enabled;
            this.threatProtectionAllowedUsers = planInfo.threat_protection.enabled && planInfo.threat_protection.allowed_users || 0;
            this.protectedUsersCount = planInfo.threat_protection.used_users;

            if (this.mailServerConnected) {
                this.getMailboxesInfo();
            }
            else {
                this.isLoaded = true;
            }

        }, (err) => {
			this.isLoaded = true;
		});
    };

    startLoadExchangeUsers =  () => {
		if (!this.graphConnected && !this.gsuiteConnected) {
			this.isLoaded = true;
			this.loadingInProcess = false;
			return;
		}

        this.subscriptionUsersNotificationIdx = this.ns.showInfoMessage('Retrieving mailboxes...', {timeout: 0});

		this.getExchangeMailboxesExecute(null);
    };

    getMailboxesInfo = () => {
        this.rs.getMailboxesInfo().then(data => {
            this.mailboxesSubscriptions = data;

            this.subscriptionUsers = [];

            if (!this.mailboxesSubscriptions.length) {
                return this.getMailboxesFromExchange();
            }

            let inactiveLimitDate = new Date();
            inactiveLimitDate.setDate(inactiveLimitDate.getDate() - this.dic.CONSTANTS.inactiveUsers);
            this.mailboxesSubscriptions.forEach((mailboxObj) => {
				if (mailboxObj.is_blocked) {
					mailboxObj.status = 'Blocked';
				}
				else {
					if (mailboxObj.is_protected) {
						mailboxObj.status = this.dic.CONSTANTS.inboundMailBoxStatus.protect;
						if (mailboxObj.last_email && new Date(mailboxObj.last_email) < inactiveLimitDate) {
							mailboxObj.status = this.dic.CONSTANTS.inboundMailBoxStatus.inactive;
						}

						if (mailboxObj.is_fes) {
							switch (this.planInfo.inbound_relay.sending_architecture) {
								case this.dic.CONSTANTS.inboundSendingArchitecture.mx:
									mailboxObj.protectedType = 'MX';
									break;

								case this.dic.CONSTANTS.inboundSendingArchitecture.connector:
									mailboxObj.protectedType = 'Relay';
									break;

								case this.dic.CONSTANTS.inboundSendingArchitecture.journal:
									mailboxObj.protectedType = 'Journal';
									break;
							}
						}
						else {
							mailboxObj.protectedType = 'API';
						}
					} else {
						mailboxObj.status = this.dic.CONSTANTS.inboundMailBoxStatus.exposed;
					}
				}
                mailboxObj.last_email_priority = !mailboxObj.last_email ? -1 : mailboxObj.last_email;

				this.getMailboxStatusTooltip(mailboxObj);

                this.subscriptionUsers.push(mailboxObj);
            });

            this.isLoaded = true;

            this.updateListView(this.mailboxListView);
        });
    };


    getMailboxesFromExchange = () => {
        this.rs.getMailboxesInfo().then(data => {
            this.mailboxesSubscriptions = data;
            this.subscriptionUsers = [];
            this.activeMailboxList = [];
            this.startLoadExchangeUsers();
        });
    };

    getMailboxesRefresh = () => {
        if (this.graphConnected || this.gsuiteConnected) {
            if (this.loadingInProcess) {
                return;
            }
            this.loadingInProcess = true;
            this.getMailboxesFromExchange();
        }
        else {
            this.getMailboxesInfo();
        }

        // sync DB and exchange mailboxes
        this.rs.updateMailboxInfo({action: this.dic.CONSTANTS.inboundMailboxAction.syncMailboxes.value}).then(() => {});

        this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
    };

    getExchangeMailboxesExecute = (nextLink) => {
        if (!this.mailServerConnected) {
            this.loadingInProcess = false;
            return;
        }

        const getUsers = this.gsuiteConnected ?
            this.rs.getGSuiteUsers() :
            this.rs.getExchangeUsers({nextLink: nextLink || ''});

        getUsers.then(data => {
            data.mailboxes.forEach(user => {
                let userSubscription = this.mailboxesSubscriptions && this.mailboxesSubscriptions.find(itm => itm.email.toLowerCase() === user.email.toLowerCase());
                if (userSubscription) {
                    user.is_protected = userSubscription.is_protected;
                    user.last_email = userSubscription.last_email;
                    user.is_fes = userSubscription.is_fes || false;
                    user.is_personal_reviewer = userSubscription.is_personal_reviewer || false;
                    user.check_impersonation = userSubscription.check_impersonation || false;
                }
                else {
                    user.is_protected = false;
                    user.is_fes = false;
                }

                user.status = user.is_protected ? this.dic.CONSTANTS.inboundMailBoxStatus.protect : this.dic.CONSTANTS.inboundMailBoxStatus.exposed;
                user.last_email_priority = !user.last_email ? -1 : user.last_email;
            });

            this.subscriptionUsers = this.subscriptionUsers.concat(data.mailboxes);
            this.updateListView(this.mailboxListView);

            if (data.nextLink) {
                setTimeout(() => {
                    this.getExchangeMailboxesExecute(data.nextLink);
                }, 1000);
            }
            else {
                this.isLoaded = true;
                this.loadingInProcess = false;
                this.ns.overwriteMessage(this.subscriptionUsersNotificationIdx, `Finished retrieving mailboxes`);
            }
        }, err => {
            this.loadingInProcess = false;
        });
    };

	getMailboxStatusTooltip = (mailboxObj) => {
		switch (mailboxObj.status) {
			case this.dic.CONSTANTS.inboundMailBoxStatus.protect:
				mailboxObj.statusToolip = 'Emails sent to this mailbox are being scanned by Inbound Shield';
				break;

			case this.dic.CONSTANTS.inboundMailBoxStatus.exposed:
				mailboxObj.statusToolip = 'Emails sent to this mailbox are currently not being scanned by Inbound Shield';
				break;

			case this.dic.CONSTANTS.inboundMailBoxStatus.inactive:
				mailboxObj.statusToolip = 'Emails sent to this mailbox have not been scanned by Inbound Shield in the past 45 days';
				break;
		}
	}

	enableApiProtection = (mailboxes, options) => {
		this.showEnableApiProtectionPopup = {
			mailboxes
		};

		if (options?.limitedMailboxes) {
			this.showEnableApiProtectionPopup.showLimitedMailboxes = true;

			mailboxes = [];
			for (let i = 0; i < this.showEnableApiProtectionPopup.mailboxes.length; i++) {
				if (this.showEnableApiProtectionPopup.mailboxes[i].license === this.dic.CONSTANTS.inboundMailboxTypes.member &&
					!this.showEnableApiProtectionPopup.mailboxes[i].is_protected) {
					mailboxes.push(this.showEnableApiProtectionPopup.mailboxes[i]);
				}
			}
			if (!mailboxes?.length) {
				this.ns.showErrorMessage("Your plan currently does not have any unprotected licenses mailboxes");
				return;
			}
			this.showEnableApiProtectionPopup.mailboxes = mailboxes;
			this.showEnableApiProtectionPopup.limitedMailboxes = mailboxes.length;

		}

		if (!this.planInfo.exchange_server?.contacts_enabled) {
			this.showEnableApiProtectionPopup.importContacts = true;
		}

		this.showEnableApiProtectionPopup.show = true;
	}


	enableApiProtectionExecute = () => {
		let mailboxes = this.showEnableApiProtectionPopup.mailboxes;
		if (this.showEnableApiProtectionPopup.showLimitedMailboxes) {
			mailboxes = [];
			for (let i = 0; i < this.showEnableApiProtectionPopup.mailboxes.length && i < this.showEnableApiProtectionPopup.limitedMailboxes; i++) {
				if (this.showEnableApiProtectionPopup.mailboxes[i].license === this.dic.CONSTANTS.inboundMailboxTypes.member) {
					mailboxes.push(this.showEnableApiProtectionPopup.mailboxes[i]);
				}
			}
		}

		if (!mailboxes?.length) {
			this.ns.showErrorMessage("No mailboxes have been selected for API protection activation");
			return;
		}

		this.showEnableApiProtectionPopup.show = false;

		if (this.showEnableApiProtectionPopup.importContacts) {
			this.importContactsFromExchangeWithoutPopup(mailboxes);
		}

		let notIdx;
		if (mailboxes.length > 1) {
			notIdx = this.ns.showInfoMessage(`Going to enable API protection on ${mailboxes.length} mailbox${mailboxes.length > 1 ? 'es' : ''}. This action can take a while, please do not close this page.`, {timeout: 0});
		}

		let enabledMailboxes = 0;
		eachLimit(mailboxes, 5, (mailboxObj, callback) => {
			if (mailboxObj.is_protected) {
				return callback();
			}

			const updateData = {
				action: this.dic.CONSTANTS.inboundMailboxAction.enable.value,
				email: mailboxObj.email
			};

			this.createSubscriptionInProcess = true;
			this.rs.updateMailboxInfo(updateData).then(response => {
				this.createSubscriptionInProcess = false;
				mailboxObj.is_protected = true;
				mailboxObj.protectedType = 'API';
				this.getMailboxStatusTooltip(mailboxObj);
				mailboxObj.status = this.dic.CONSTANTS.inboundMailBoxStatus.protect;
				this.protectedUsersCount++;
				enabledMailboxes++;
				if (notIdx) {
				}					this.ns.overwriteMessage(notIdx, `API protection has been enabled for ${enabledMailboxes} mailboxes...`);

				callback();
			}, err => {
				console.log('Err: ', err);
				callback();
			});
		}, (err) => {
			if (enabledMailboxes) {
				this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			}
			this.createSubscriptionInProcess = false;
		});
	}

	disableApiProtection = (users) => {
		this.gs.showPopup({
			title: `Disable Protection`,
			subTitle: `Are you sure you want to disable protection for ${users.length > 1 ? `${users.length} mailboxes` : users[0].email}?`,
			body: ['For mailboxes that are protected via the inbound relay, emails sent to this mailbox will automatically enable protection on it again.' +
			' To resolve this, you can exclude the mailbox(es) from your Trustifi inbound mail flow rule.'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Disable',
			doneCb: () => {
				eachLimit(users, 1, (mailboxObj, callback) => {
					if (!mailboxObj.is_protected) {
						return callback();
					}

					if (mailboxObj.is_fes) {
						this.resetInboundRelayExecute(mailboxObj);
						return callback();
					}

					const updateData = {
						action: this.dic.CONSTANTS.inboundMailboxAction.disable.value,
						email: mailboxObj.email
					};

					this.createSubscriptionInProcess = true;
					this.rs.updateMailboxInfo(updateData).then(response => {
						this.createSubscriptionInProcess = false;
						mailboxObj.is_protected = false;
						mailboxObj.status = this.dic.CONSTANTS.inboundMailBoxStatus.exposed;
						this.protectedUsersCount--;
						this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
						callback();
					}, err => {
						console.log('Err: ', err);
						callback();
					});
				}, (err) => {
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
					this.createSubscriptionInProcess = false;
				});
			}
		});
	}

	showMailboxActions = (mailboxObj) => {
		return _.compact([
			this.dic.CONSTANTS.inboundMailboxAction.mailboxSettings.display,
			mailboxObj.is_protected && {
				display: this.dic.CONSTANTS.inboundMailboxAction.importContacts.display,
				submenu: ['From Email Server', 'From CSV']
			},

			!mailboxObj.is_protected && this.graphConnected && this.dic.CONSTANTS.inboundMailboxAction.enable.display,

			this.dic.CONSTANTS.inboundMailboxAction.setAlias.display,
			this.dic.CONSTANTS.inboundMailboxAction.inviteAdmin.display,
			(mailboxObj.is_fes || !mailboxObj.is_protected) ? this.dic.CONSTANTS.inboundMailboxAction.reset.display : this.dic.CONSTANTS.inboundMailboxAction.disable.display,
			// TODO: temporary gate (EMDR security reviewer or this plan only). Remove the condition to enable for all clients
			(this.userInfo?.is_security_reviewer || mailboxObj.plan_id === this.subscriptionBombingPlanId) && {
				display: this.dic.CONSTANTS.inboundMailboxAction.subscriptionBombing.display,
				submenu: [
					{value: 'enableSubscriptionBombing', display: 'Enable'},
					{value: 'disableSubscriptionBombing', display: 'Disable'}
				]
			},
			this.dic.CONSTANTS.inboundMailboxAction.delete.display
		]);
	}

	selectMailboxAction =  (mailbox, action) => {
        if (!mailbox) {
            return;
        }

        switch (action) {
            case this.dic.CONSTANTS.inboundMailboxAction.enable.display:
				this.enableApiProtection([mailbox], null);
				break;

            case this.dic.CONSTANTS.inboundMailboxAction.disable.display:
				this.disableApiProtection([mailbox]);
                break;

			case this.dic.CONSTANTS.inboundMailboxAction.setAlias.display:
				this.setMailboxAliasPopup(mailbox);
				break;

            case this.dic.CONSTANTS.inboundMailboxAction.mailboxSettings.display:
                this.setUserSettingsPopup(mailbox);
                break;

            case this.dic.CONSTANTS.inboundMailboxAction.reset.display:
                this.resetInboundRelay(mailbox);
                break;

			case this.dic.CONSTANTS.inboundMailboxAction.delete.display:
				this.deleteMailbox([mailbox]);
				break;

			case this.dic.CONSTANTS.inboundMailboxAction.inviteAdmin.display:
				this.openInviteUserPopup([mailbox]);
				break;

			// import contacts:
			case 'From CSV':
				this.importContactsFromCSV([mailbox]);
				break;

			case 'From Email Server':
				this.importContactsFromEmailServer([mailbox]);
				break;
		}

		if (action.value) {
			switch (action.value) {
				case 'enableSubscriptionBombing':
					this.setMultipleSubscriptionBombing([mailbox], true);
					break;

				case 'disableSubscriptionBombing':
					this.setMultipleSubscriptionBombing([mailbox], false);
					break;
			}
		}
    };

	showMultipleMailboxesActions = () => {
		return _.compact([
			this.graphConnected && this.dic.CONSTANTS.inboundMailboxAction.enable.display,
			this.dic.CONSTANTS.inboundMailboxAction.disable.display,
			{
				display: this.dic.CONSTANTS.inboundMailboxAction.importContacts.display,
				submenu: ['From Email Server', 'From CSV']
			},
			{
				display: this.dic.CONSTANTS.inboundMailboxAction.checkImpersonation.display,
				submenu: [
					{value: 'enableCheckImpersonation', display: 'Enable'},
					{value: 'disableCheckImpersonation', display: 'Disable'}
				]
			},
			{
				display: this.dic.CONSTANTS.inboundMailboxAction.viewContentPermission.display,
				submenu: [
					{value: 'enableViewContentPermission', display: 'Enable'},
					{value: 'disableViewContentPermission', display: 'Disable'}
				]
			},
			this.planInfo.threat_protection?.allow_billable_mailboxes && {
				display: this.dic.CONSTANTS.inboundMailboxAction.setBillable.display,
				submenu: [
					{value: 'enableMailboxBillable', display: 'Enable'},
					{value: 'disableMailboxBillable', display: 'Disable'}
				]
			},
			this.dic.CONSTANTS.inboundMailboxAction.inviteAdmins.display,
			{
				display: this.dic.CONSTANTS.inboundMailboxAction.scanThreatAI.display,
				submenu: [
					{value: 'enableScanThreatAI', display: 'Enable'},
					{value: 'disableScanThreatAI', display: 'Disable'}
				]
			},
			// TODO: temporary gate (EMDR security reviewer or this plan only). Remove the condition to enable for all clients
			(this.userInfo?.is_security_reviewer || this.mailboxesSubscriptions?.[0]?.plan_id === this.subscriptionBombingPlanId) && {
				display: this.dic.CONSTANTS.inboundMailboxAction.subscriptionBombing.display,
				submenu: [
					{value: 'enableSubscriptionBombing', display: 'Enable'},
					{value: 'disableSubscriptionBombing', display: 'Disable'}
				]
			},
			this.dic.CONSTANTS.inboundMailboxAction.delete.display,
		]);
	};


	selectMultipleMailboxesAction = (selectedItems, action) => {
        switch (action) {
            case this.dic.CONSTANTS.inboundMailboxAction.enable.display:
				this.enableApiProtection(selectedItems, null);
				break;

            case this.dic.CONSTANTS.inboundMailboxAction.disable.display:
                this.disableApiProtection(selectedItems);
                break;

			case this.dic.CONSTANTS.inboundMailboxAction.delete.display:
				this.deleteMailbox(selectedItems);
				break;

			case this.dic.CONSTANTS.inboundMailboxAction.inviteAdmins.display:
				this.openInviteUserPopup(selectedItems);
				break;

			// import contacts:
			case 'From CSV':
				this.importContactsFromCSV(selectedItems);
				break;

			case 'From Email Server':
				this.importContactsFromEmailServer(selectedItems);
				break;
		}

		if (action.value) {
			switch (action.value) {
				case 'enableCheckImpersonation':
					this.setMultipleCheckImpersonation(selectedItems, true);
					break;

				case 'disableCheckImpersonation':
					this.setMultipleCheckImpersonation(selectedItems, false);
					break;

				case 'enableViewContentPermission':
					this.setMultipleViewContentPermission(selectedItems, true);
					break;

				case 'disableViewContentPermission':
					this.setMultipleViewContentPermission(selectedItems, false);
					break;

				case 'enableMailboxBillable':
					this.setMailboxBillable(selectedItems, true);
					break;

				case 'disableMailboxBillable':
					this.setMailboxBillable(selectedItems, false);
					break;

				case 'enableScanThreatAI':
					this.setMultipleScanThreatAI(selectedItems, true);
					break;

				case 'disableScanThreatAI':
					this.setMultipleScanThreatAI(selectedItems, false);
					break;

				case 'enableSubscriptionBombing':
					this.setMultipleSubscriptionBombing(selectedItems, true);
					break;

				case 'disableSubscriptionBombing':
					this.setMultipleSubscriptionBombing(selectedItems, false);
					break;
			}
		}
    };

	changeNotifyPeriod = () => {
		if (this.changeUserSettingsPopup.inProcess) {
			return;
		}

		if (!this.changeUserSettingsPopup.notificationSched.notifyRecipientAllowChangeTime) {
			this.ns.showErrorMessage('You need to enable checkbox: Allow users to set their own custom notification times');
			return;
		}

		// periods validation
		const isOneReviewerPeriodEnabled = _.some(this.changeUserSettingsPopup.notificationSched.periods, period => {return !!period});
		if (!isOneReviewerPeriodEnabled) {
			this.changeUserSettingsPopup.notificationSched.isNotifyReviewerPeriodsError = true;
		}

		this.changeUserSettingsPopup.notificationSched.isNotifyReviewerDailyHoursError = this.changeUserSettingsPopup.notificationSched.periods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !this.changeUserSettingsPopup.notificationSched.dailyHours.length;
		this.changeUserSettingsPopup.notificationSched.isNotifyReviewerDaysError = this.changeUserSettingsPopup.notificationSched.periods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !_.some(this.changeUserSettingsPopup.notificationSched.notifyReviewerDays, { selected: true });
		if (!isOneReviewerPeriodEnabled || this.changeUserSettingsPopup.notificationSched.isNotifyReviewerDailyHoursError || this.changeUserSettingsPopup.notificationSched.isNotifyReviewerDaysError) {
			return;
		}
		//

		// make arrays of strings from the periods objects (pick only enabled periods)
		const notifyReviewerPeriodsArr = _.keys(_.pickBy(this.changeUserSettingsPopup.notificationSched.periods));

		// turn the local hours in the "daily_hour" models into UTC hours for the BE
		let notifyReviewerDailyHoursUTC = _.cloneDeep(this.changeUserSettingsPopup.notificationSched.dailyHours);
		for (let i =0 ; i < notifyReviewerDailyHoursUTC.length; i++) {
			let formattedHour:any = new Date();
			formattedHour.setHours(notifyReviewerDailyHoursUTC[i]);
			formattedHour = (formattedHour.getUTCHours() < 10 ? '0' : '') + formattedHour.getUTCHours();
			notifyReviewerDailyHoursUTC[i] = formattedHour;
		}
		//

		const selectedNotifyReviewerDays = _.map(
			_.filter(this.changeUserSettingsPopup.notificationSched.notifyReviewerDays, { selected: true }),
			'day'
		);

		const data = {
			email: this.changeUserSettingsPopup.mailbox.email,
			action: this.dic.CONSTANTS.inboundMailboxAction.editMailboxNotifyPeriods.value,
			notifyReviewerPeriods: notifyReviewerPeriodsArr,
			notify_reviewer_daily_hour: notifyReviewerDailyHoursUTC.join(', '),
			notify_reviewer_days: selectedNotifyReviewerDays
		};

		this.changeUserSettingsPopup.inProcess = true;

		this.rs.updateMailboxInfo(data).then( (response) => {
			this.changeUserSettingsPopup.mailbox.notify_reviewer_periods = notifyReviewerPeriodsArr;
			this.changeUserSettingsPopup.mailbox.notify_reviewer_daily_hour = notifyReviewerDailyHoursUTC.join(', ');
			this.changeUserSettingsPopup.mailbox.notify_reviewer_days = selectedNotifyReviewerDays;
			this.planInfo.threat_protection.rules.notify_recipient_allow_change_time = true;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
			this.changeUserSettingsPopup.editNotificationSched = null;
			this.changeUserSettingsPopup.inProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.changeUserSettingsPopup.inProcess = false;
		});
	};

	setCheckImpersonationForMailbox = (mailboxObj) => {
		const updateData = {
			action: this.dic.CONSTANTS.inboundMailboxAction.checkImpersonation.value,
			email: mailboxObj.email,
			enabled: mailboxObj.check_impersonation
		};

		this.rs.updateMailboxInfo(updateData).then(response => {
		}, err => {
			console.log('Err: ', err);
		});
	};

	setScanThreatAIForMailbox = (mailboxObj) => {
		const updateData = {
			action: this.dic.CONSTANTS.inboundMailboxAction.scanThreatAI.value,
			email: mailboxObj.email,
			enabled: mailboxObj.scan_threat_ai
		};

		this.rs.updateMailboxInfo(updateData).then(response => {
		}, err => {
			console.log('Err: ', err);
		});
	}

	setSubscriptionBombingForMailbox = (mailboxObj) => {
		const updateData = {
			action: this.dic.CONSTANTS.inboundMailboxAction.subscriptionBombing.value,
			email: mailboxObj.email,
			enabled: mailboxObj.subscription_bombing
		};

		this.rs.updateMailboxInfo(updateData).then(response => {
		}, err => {
			mailboxObj.subscription_bombing = !updateData.enabled;
			if (err?.data?.message) {
				this.ns.showErrorMessage(err.data.message);
			}
		});
	}

	setViewContentPermissionReviewers = (mailboxObj) => {
		const updateData = {
			action: this.dic.CONSTANTS.inboundMailboxAction.viewContentPermission.value,
			email: mailboxObj.email,
			enabled: mailboxObj.view_content.allow_reviewers,
			type: 'allow_reviewers'
		};

		this.rs.updateMailboxInfo(updateData).then(response => {
		}, err => {
			console.log('Err: ', err);
		});
	}

	setViewContentPermissionAdmins = (mailboxObj) => {
		const updateData = {
			action: this.dic.CONSTANTS.inboundMailboxAction.viewContentPermission.value,
			email: mailboxObj.email,
			enabled: mailboxObj.view_content.allow_admins,
			type: 'allow_admins'
		};

		this.rs.updateMailboxInfo(updateData).then(response => {
		}, err => {
			console.log('Err: ', err);
		});
	}

    openProtectGroupsPopup = (show) => {
        this.showProtectGroups = show;
    };

    applyProtectGroupsPopup = (groups) => {
		const usersToApply = [];
        groups.forEach((groupObj) => {
            if (groupObj.selected && groupObj.members?.length) {
				groupObj.members.forEach((memberObj) => {
					this.subscriptionUsers.forEach((mailboxObj) => {
						if (memberObj.email === mailboxObj.email.toLowerCase()) {
							usersToApply.push(mailboxObj);
						}
					});
				});
            }
        });

        this.showProtectGroups = false;
		this.selectMultipleMailboxesAction(usersToApply, this.dic.CONSTANTS.inboundMailboxAction.enable.display);
    };


    protectMailboxesFromCsv = (file) => {
        if (!file) return;
        const validationFunctions = [this.gs.validateEmail];
        this.gs.readCsv(file, ['email'], null, this.dic.CONSTANTS.EMAIL_REGEX, validationFunctions, (err, results) => {
            if (err) {
                return;
            }

			const usersToApply = [];
			results['email'].forEach((emailAddress) => {
				this.subscriptionUsers.forEach((mailboxObj) => {
					if (emailAddress === mailboxObj.email.toLowerCase()) {
						usersToApply.push(mailboxObj);
					}
				});
			});

			this.selectMultipleMailboxesAction(usersToApply, this.dic.CONSTANTS.inboundMailboxAction.enable.display);
        });
    };

	searchMailbox = (searchTerm, activeFilters) => {
		this.activeMailboxList.forEach(record => {
			if (!searchTerm && !activeFilters) {
				showAllSubMailboxes(record);
			}

			// search + filter

			const isFound = this.searchMailboxExecute(record, searchTerm, activeFilters);
			if (!isFound) {
				record.hide = true;
				return;
			}

			record.displayedCounter = record.mailboxes?.length && _.reject(record.mailboxes, 'hide').length;

			record.hide = false;
		});

		this.doNotChangeIsExpandedStates = false;
	};

    exportMailboxesCsv = (sortBy) => {
		if (!this.activeMailboxList?.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

        let csvString = this.mailboxListView === this.dic.CONSTANTS.userMgmntListViews.domains ? 'Domain,' : '';
		csvString += `Name,Email Address,Job Role,Status,Type,Last Email\n`;

		let sortedTable = _.reject(this.activeMailboxList, 'hide');
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

		// flatten the users list from in-depth users
		sortedTable = this.flattenMailboxesList(sortedTable);

		sortedTable.forEach((mailbox) => {
			const statusMode = mailbox.is_protected && (mailbox.is_fes ? ' (Relay)' : ' (API)') || ''

			if (this.mailboxListView === this.dic.CONSTANTS.userMgmntListViews.domains) {
				if (mailbox.isDomainTitleRecord) {
					csvString += `${mailbox.domainName}\n`;
				}
				else {
					csvString += `,"${mailbox.name}",${mailbox.email},"${mailbox.job_title || 'N/A'}",${mailbox.status + (statusMode)},${mailbox.license},${mailbox.last_email || 'None'}\n`;
				}
			}
			else {
				csvString += `"${mailbox.name}",${mailbox.email},"${mailbox.job_title || 'N/A'}",${mailbox.status + (statusMode)},${mailbox.license},${mailbox.last_email || 'None'}\n`;
			}
        });

        this.gs.exportCsv(csvString, `inbound_mailboxes.csv`);
    };

	flattenMailboxesList =(list) => {
		let flatList = [];
		list.forEach(mailboxOrDomain => {
			if (!mailboxOrDomain.mailboxes?.length) {
				flatList.push(mailboxOrDomain);
			}
			else {
				flatList.push(mailboxOrDomain);
				flatList = flatList.concat(this.flattenMailboxesList(mailboxOrDomain.mailboxes));
			}
		});
		return flatList;
	}


	deleteMailbox = (users) => {
		const title = users.length > 1 ? `Delete ${users.length} Mailboxes` : `Delete Mailbox ${users[0].email}`;
		const subTitle = users.length > 1 ? `You are about to delete ${users.length} Mailboxes` : `You are about to delete mailbox ${users[0].email}`;

		this.gs.showPopup({
			title: title,
			subTitle: subTitle,
			body: ['If this mailbox is still connected to inbound protection it will be created again when it receives a new email'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				users.forEach((user) => {
					this.deleteMailboxExecute(user);
				});
			}
		});
	};

	deleteMailboxExecute = (mailbox) => {
		const data = {
			action: this.dic.CONSTANTS.inboundMailboxAction.delete.value,
			email: mailbox.email
		};
		this.rs.updateMailboxInfo(data).then(() => {
			this.protectedUsersCount--;
			_.remove(this.activeMailboxList, {email: mailbox.email})
		});
	}


	resetInboundRelay = (user) => {
        this.gs.showPopup({
            title: `Reset protection for ${user.email}`,
            subTitle: `You are about to reset the Inbound Email Relay for ${user.email}`,
            body: ['Inbound Email Relay will be re-enabled when an email arrives to this mailbox'],
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Reset',
            doneCb: () => {
                this.resetInboundRelayExecute(user);
            }
        });
    };

    resetInboundRelayExecute = (mailboxObj) => {
		const data = {
			action: this.dic.CONSTANTS.inboundMailboxAction.reset.value,
			email: mailboxObj.email
		};
        this.rs.updateMailboxInfo(data).then(() => {
            mailboxObj.is_fes = false;
            mailboxObj.is_protected = false;

            let userSubscription = this.mailboxesSubscriptions && this.mailboxesSubscriptions.find(itm => itm.email === mailboxObj.email);
            if (userSubscription) {
                if (userSubscription.mailbox_subscription) {
                    mailboxObj.is_protected = true;
                }
                else {
                    mailboxObj.is_protected = false;
                    this.protectedUsersCount--;
                }
            }
            else {
                mailboxObj.is_protected = false;
            }

            mailboxObj.status = mailboxObj.is_protected ? this.dic.CONSTANTS.inboundMailBoxStatus.protect : this.dic.CONSTANTS.inboundMailBoxStatus.exposed;
			this.getMailboxStatusTooltip(mailboxObj);
        });
    }

    setUserSettingsPopup = (mailbox) => {
		const tabs = {
			general: 'General',
			scanMetrics: 'Scan Metrics',
			personalReviewer: 'Personal Reviewer',
			viewContentPermission: 'View Content Permission'
		};

		// Initialize notification scheduled tab
		const notifyReviewerDays = _.map(this.gs.daysArr, day => ({
			day: day,
			selected: mailbox.notify_reviewer_days?.includes(day) || false
		}));

		const notifyReviewerPeriods = {};
		_.forEach(this.dic.CONSTANTS.tpRule.notifyOptions,(periodName, periodKey) => {
			notifyReviewerPeriods[periodName] = mailbox.notify_reviewer_periods?.includes(periodName);
		});
		let notifyReviewerDailyHours = [];
		if (mailbox.notify_reviewer_daily_hour) {
			notifyReviewerDailyHours = mailbox.notify_reviewer_daily_hour.split(', ');
			for (let i = 0; i < notifyReviewerDailyHours.length; i++) {
				let formattedHour:any = new Date();
				formattedHour.setUTCHours(notifyReviewerDailyHours[i]);
				formattedHour = (formattedHour.getHours() < 10 ? '0' : '') + formattedHour.getHours();
				notifyReviewerDailyHours[i] = formattedHour;
			}
		}

		//

		this.changeUserSettingsPopup = {
			show: true,
			tabs,
			activeTab: tabs.general,
			mailbox,

			notificationSched: {
				periods: notifyReviewerPeriods,
				dailyHours: notifyReviewerDailyHours,
				notifyReviewerDays,
				isNotifyReviewerPeriodsError: false,
				isNotifyReviewerDailyHoursError: false,
				changeNotifyPeriodInProcess: false,
				notifyRecipientAllowChangeTime: this.planInfo.threat_protection.rules.notify_recipient_allow_change_time,
			}
		};
		console.log(mailbox.notify_reviewer_daily_hour);
		console.log(mailbox.notify_reviewer_days);
    }

	updateMailboxJobTitle = (mailboxObj, jobObj) => {
		if (this.changeUserSettingsPopup.inProcess) {
			return;
		}
		if (!jobObj?.name) {
			return;
		}

		const updateData:any = {
			action: this.dic.CONSTANTS.inboundMailboxAction.jobTitle.value,
			email: mailboxObj.email,
			job_title: jobObj.name.trim(),
			is_executive: jobObj.is_executive
		};

		this.changeUserSettingsPopup.inProcess = true;

		this.rs.updateMailboxInfo(updateData).then(() => {
			mailboxObj.job_title = jobObj.name;
			mailboxObj.is_executive = jobObj.is_executive;

			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.changeUserSettingsPopup.editJobTitle = null;
			this.changeUserSettingsPopup.inProcess = false;
		}, (err) => {
			if (!err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.changeUserSettingsPopup.inProcess = false;
		});
	}

	setMailboxAliasPopup = (mailbox) => {
		this.mailboxAliasPopup = {
			mailbox: mailbox,
			aliasInput: '',
			show: true,
			doneCb: () => {
				if (this.mailboxAliasPopup.InProcess) {
					return;
				}
				if (!this.mailboxAliasPopup.aliasInput) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.emptyField, 'Mailbox'));
					return;
				}
				if (!this.gs.validateEmail(this.mailboxAliasPopup.aliasInput)) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.invalidEmail, this.mailboxAliasPopup.aliasInput));
					return;
				}

				this.mailboxAliasPopup.InProcess = true;

				const updateData:any = {
					action: this.dic.CONSTANTS.inboundMailboxAction.setAlias.value,
					email: this.mailboxAliasPopup.mailbox.email,
					alias: this.mailboxAliasPopup.aliasInput.toLowerCase()
				};

				this.rs.updateMailboxInfo(updateData).then(() => {
					if (this.mailboxesSubscriptions.find(itm => itm.email && itm.email.toLowerCase() === updateData.alias)) {
						_.remove<any>(this.mailboxesSubscriptions, (itm:any) => itm.email && itm.email.toLowerCase() === updateData.alias);
					}
					else {
						this.mailboxAliasPopup.mailbox.email = updateData.alias;
					}

					this.mailboxAliasPopup = null;

					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, (err) => {
					this.mailboxAliasPopup.InProcess = false;
					if (!err.data.display_bar) {
						this.ns.showErrorMessage(err.data.message);
					}
				});
			}
		};
	}


	openInviteUserPopup = (mailboxes) => {
		const mailboxUsers = mailboxes.map(user => ({
			name: user.name,
			email: user.email
		}));
		this.inviteUserPopup = {
			mailboxes: mailboxUsers,
			title: mailboxUsers.length > 1 ? `Invite Admins` : `Invite Admin`,
			inProcess: false,
			show: true,

			doneCb: () => {
				this.inviteUserPopup.inProcess = true;
				this.rs.inviteUserToSharedPlan({
					emails: mailboxUsers,
					admin_permissions: {enabled: true},
					source: 'inbound'
				}).then(() => {
					this.ns.showInfoMessage(mailboxUsers.length > 1 ? `Users have been invited successfully` : `User has been invited successfully`);
					this.inviteUserPopup = null;
				}, (err) => {
					if (err.data && err.data.message) {
						if (!err.data.display_bar) {
							this.ns.showErrorMessage(err.data.message);
						}
						this.inviteUserPopup = null;
					}
				});
			}
		};
	}

    updatePersonalReviewer = (mailbox) => {
        if (this.changeUserSettingsPopup.inProcess) {
            return;
        }

        const updateData:any = {
            action: this.dic.CONSTANTS.inboundMailboxAction.editPersonalReviewer.value,
            email: mailbox.email,
            isPersonalReviewer: mailbox.is_personal_reviewer,
            reviewerAllowReleaseMalicious: mailbox.reviewer_allow_release_malicious
        };

        this.changeUserSettingsPopup.inProcess = true;
        this.rs.updateMailboxInfo(updateData).then(() => {
			this.changeUserSettingsPopup.inProcess = false;
        }, (err) => {
            this.changeUserSettingsPopup.inProcess = false;
            if (!err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
        });
    }

    importContactsFromEmailServer = (mailboxes) => {
        if (!mailboxes?.length) {
            return this.ns.showWarnMessage(this.dic.ERRORS.mailboxesImportContacts);
        }

		if (this.planInfo.gsuite_server?.enabled) {
			this.importContactsFromGoogle(mailboxes);
		}
		else {
			this.importContactsFromExchange(mailboxes);
		}
    };

	setMailboxBillable = (mailboxes, enabled) => {
		this.gs.showPopup({
			title: enabled ? "Count as Licensed Mailbox" : "Disable Count as Licensed Mailbox",
			subTitle: `Set license status for ${mailboxes.length} mailboxes`,
			body: [`This selected mailboxes will ${enabled ? '' : 'not'} be included in your license usage and billed accordingly`],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Confirm',
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					this.setMailboxBillableExecute(mailboxObj, enabled);
				});
			}
		});
	};

	setMailboxBillableExecute = (mailboxObj, enabled) => {

		const updateDataAdmin = {
			action: this.dic.CONSTANTS.inboundMailboxAction.setBillable.value,
			email: mailboxObj.email,
			billable: enabled
		};

		this.rs.updateMailboxInfo(updateDataAdmin).then(response => {
			if (mailboxObj.is_protected) {
				if (enabled) {
					this.protectedUsersCount++;
				}
				else {
					this.protectedUsersCount--;
				}
			}

			mailboxObj.billable = enabled;

		}, err => {
			console.log('Err: ', err);
		});
	};


	setMultipleViewContentPermission = (mailboxes, enabled) => {
		this.gs.showPopup({
			title: `${enabled ? 'Enable' : 'Disable'} View Content Permissions`,
			subTitle: `Configure permissions for ${mailboxes.length} mailboxes`,
			body: [`All inbound reviewers and admins will ${enabled ? '' : 'not '}be able to view quarantined email content for these mailboxes`],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Confirm',
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					mailboxObj.view_content.allow_admins = enabled;
					mailboxObj.view_content.allow_reviewers = enabled;

					const updateDataAdmin = {
						action: this.dic.CONSTANTS.inboundMailboxAction.viewContentPermission.value,
						email: mailboxObj.email,
						enabled: mailboxObj.view_content.allow_admins,
						type: 'allow_admins'
					};

					this.rs.updateMailboxInfo(updateDataAdmin).then(response => {
					}, err => {
						console.log('Err: ', err);
					});


					const updateDataReviewers = {
						action: this.dic.CONSTANTS.inboundMailboxAction.viewContentPermission.value,
						email: mailboxObj.email,
						enabled: mailboxObj.view_content.allow_reviewers,
						type: 'allow_reviewers'
					};

					this.rs.updateMailboxInfo(updateDataReviewers).then(response => {
					}, err => {
						console.log('Err: ', err);
					});
				});
			}
		});
	};


	setMultipleCheckImpersonation = (mailboxes, enabled) => {
        let title, body = [], type;
        if (enabled) {
            title = 'enable';
            body.push('The sender will be checked to see if they are impersonating the recipient\'s contacts');
            type = this.dic.CONSTANTS.popupInfo;
        }
        else {
            title = 'disable';
            body.push('The sender will not be checked to see if they are impersonating the recipient\'s contacts.');
            type = this.dic.CONSTANTS.popupWarning;
        }
        this.gs.showPopup({
            title: `${this.gs.toCapitalize(title)} impersonation check`,
            subTitle: `You are about to ${title} impersonation check for ${mailboxes.length} mailboxes`,
            body: body,
            type: type,
            doneBtnText: this.gs.toCapitalize(title),
            doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					mailboxObj.check_impersonation = enabled;
					this.setCheckImpersonationForMailbox(mailboxObj);
				});
            }
        });
    };

	setMultipleScanThreatAI = (mailboxes, enabled) => {
		let title, subTitle;
		if (enabled) {
			title = 'enable';
			subTitle = 'Incoming emails will be scanned using AI to detect Business Email Compromise (BEC) attacks';
		}
		else {
			title = 'disable';
			subTitle = 'Incoming emails will not be scanned using AI to detect Business Email Compromise (BEC) attacks';
		}
		this.gs.showPopup({
			title: `${this.gs.toCapitalize(title)} Scan Threat AI`,
			subTitle: subTitle,
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: this.gs.toCapitalize(title),
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					mailboxObj.scan_threat_ai = enabled;
					this.setScanThreatAIForMailbox(mailboxObj);
				});
			}
		});
	};

	setMultipleSubscriptionBombing = (mailboxes, enabled) => {
		const title = enabled ? 'enable' : 'disable';
		const body = enabled ?
			['Sign-up, registration, activation, verification, welcome and confirmation emails from unfamiliar senders will be tagged as Graymail with the sub-status "Subscription Bombing"', 'Trusted and known senders are not affected'] :
			['Subscription bombing emails will no longer be detected for these mailboxes'];
		this.gs.showPopup({
			title: `${this.gs.toCapitalize(title)} Subscription Bombing Protection`,
			subTitle: `You are about to ${title} subscription bombing protection for ${mailboxes.length} mailboxes`,
			body: body,
			type: enabled ? this.dic.CONSTANTS.popupInfo : this.dic.CONSTANTS.popupWarning,
			doneBtnText: this.gs.toCapitalize(title),
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					mailboxObj.subscription_bombing = enabled;
					this.setSubscriptionBombingForMailbox(mailboxObj);
				});
			}
		});
	};

    importContactsFromGoogle = (mailboxes) => {
        if (this.planInfo.gsuite_server?.enabled) {
            this.importContactsFromGooglePopup(mailboxes);
        }
        else {
            this.ns.showWarnMessage('Please go to the Inbound -> Plan Settings page and connect to Google Workspace.');
        }
    };

    importContactsFromExchange = (mailboxes) => {
        if (!this.planInfo.exchange_server.enabled) {
            this.ns.showWarnMessage('Please go to the Inbound -> Plan Settings page and connect to the Exchange Server.');
            return;
        }

        if (this.planInfo.exchange_server && this.planInfo.exchange_server.contacts_enabled) {
            this.importContactsFromExchangePopup(mailboxes);
        }
        else {
            this.authService.authMicrosoftExchangeContacts(this.userInfo.email, this.planInfo.exchange_server.tid, this.planInfo.exchange_server.azuread_endpoint, this.planInfo.exchangeContactAppId, this.planInfo.exchangeAdminAppId, (err) => {
                if (err) {
                    if (err !== true) this.ns.showWarnMessage(err);
                }
                else {
                    this.planInfo.exchange_server.contacts_enabled = true;
                    this.importContactsFromExchangePopup(mailboxes);
                }
            });
        }
    };

    importContactsFromGooglePopup = (mailboxes) => {
        this.gs.showPopup({
            title: `Import Contacts From Google GSuite`,
            subTitle: `You are about to import contacts from Google GSuite`,
            body: ["The user's contacts will be imported from Google GSuite into their Trustifi contact list",
                "Importing user contacts is highly recommended to help prevent contact impersonation attacks."],
            type: this.dic.CONSTANTS.popupInfo,
            doneBtnText: 'Import',
            doneCb: () => {
                this.importContactsFromExchangeExecute(mailboxes);
            }
        });
    };

    importContactsFromExchangePopup = (mailboxes) => {
        this.gs.showPopup({
            title: `Import Contacts From Exchange`,
            subTitle: `You are about to import contacts from Exchange`,
            body: ["The user's contacts will be imported from Exchange into their Trustifi contact list", "Importing user contacts is highly recommended to help prevent contact impersonation attacks."],
            type: this.dic.CONSTANTS.popupInfo,
            doneBtnText: 'Import',
            doneCb: () => {
                this.importContactsFromExchangeExecute(mailboxes);
            }
        });
    };

    importContactsFromExchangeWithoutPopup = (mailboxes) => {
        this.authService.authMicrosoftExchangeContacts(this.userInfo.email, this.planInfo.exchange_server.tid, this.planInfo.exchange_server.azuread_endpoint, this.planInfo.exchangeContactAppId, this.planInfo.exchangeAdminAppId, (err) => {
            if (err) {
                if (err !== true) this.ns.showWarnMessage(err);
            }
            else {
                this.planInfo.exchange_server.contacts_enabled = true;
                this.importContactsFromExchangeExecute(mailboxes);
            }
        });
    };

    importContactsFromExchangeExecute = (mailboxes) => {
        mailboxes.forEach(mailbox => {
			if (mailbox.is_protected) {
				const data = {
					action: this.dic.CONSTANTS.inboundMailboxAction.importContacts.value,
					email: mailbox.email
				};

				this.rs.updateMailboxInfo(data).then(() => {
					this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Contacts'));
				}, err => {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.remainedUnprotected, mailbox.email));
				});
			}
        });
    };

    importContactsFromCSV = (mailboxes) => {
		if (!mailboxes?.length) {
			return this.ns.showWarnMessage(this.dic.ERRORS.mailboxesImportContacts);
		}

        const body = [
            'File type must be a Comma Separated Value (.csv).',
            'The first row must contain the field names.',
            'Email addresses should appear in the Email column.',
            'Complex text fields (that include spaces or other symbols) must be surrounded with double quotation marks.',
            'Optional columns: "Name", "Country_code", "Phone_number".'
        ];
        this.gs.showPopup({
            title: 'Import Contacts From CSV',
            subTitle: 'To ensure ' + this.gs.corpname + ' can successfully handle your data, it should meet the following conditions:',
            body: body,
            type: this.dic.CONSTANTS.popupInfo,
            doneBtnText: 'OK',
            isFile: true,
            doneCb: (file) => {
                if (!file || !file.length) return;
                const validationFunctions = [this.gs.validateEmail];
                this.gs.readCsv(file[0], ['email'], ['name', 'country_code', 'phone_number'], this.dic.CONSTANTS.EMAIL_REGEX, validationFunctions, (err, results) => {
                    if (err || !results.email || !results.email.length) {
                        return;
                    }
                    let contacts = [], contact;
                    for (let i = 0; i < results.email.length; i++) {
                        contact = {};
                        contact.email = results.email[i];
                        if (results.name && results.name[i]) {
                            contact.name = results.name[i];
                        }
                        if (results.country_code && results.country_code[i] && results.phone_number && results.phone_number[i]) {
                            contact.phone = {
                                country_code: results.country_code[i],
                                phone_number: results.phone_number[i]
                            }
                        }

                        contacts.push(contact);
                    }
                    this.mailboxIndexInProcess = 0;
                    const notificationIdx = this.ns.showInfoMessage(util.format(this.dic.MESSAGES.importContactsStart, mailboxes.length));
                    this.importContactsFromCSVExecute(mailboxes, contacts, notificationIdx);
                });
            }
        });
    };

    importContactsFromCSVExecute = (mailboxes, contacts, notificationIdx) => {
		const data = {
			action: this.dic.CONSTANTS.inboundMailboxAction.uploadContacts.value,
			email: mailboxes[this.mailboxIndexInProcess].email,
			contacts: contacts
		};
        this.rs.updateMailboxInfo(data).then(() => {
            this.mailboxIndexInProcess++;
            this.ns.overwriteMessage(notificationIdx, util.format(this.dic.MESSAGES.importContactsProgress, this.mailboxIndexInProcess, mailboxes.length));
            if (this.mailboxIndexInProcess < mailboxes.length) {
                this.importContactsFromCSVExecute(mailboxes, contacts, notificationIdx);
            }
            else {
                this.ns.overwriteMessage(notificationIdx, util.format(this.dic.MESSAGES.itemAdded, 'Contacts'));
            }
        });
    };

    initFilters = () => {
		const filters = {
			license: [this.dic.CONSTANTS.inboundMailboxTypes.member, this.dic.CONSTANTS.inboundMailboxTypes.guest,
				this.dic.CONSTANTS.inboundMailboxTypes.unlicensed, this.dic.CONSTANTS.inboundMailboxTypes.onpremises,
				this.dic.CONSTANTS.inboundMailboxTypes.disabled],
			status: [this.dic.CONSTANTS.inboundMailBoxStatus.protect, this.dic.CONSTANTS.inboundMailBoxStatus.exposed],
			'email relay': [true, false],
			'executives': [true, false],
			'personal reviewer': [true, false, 'Allow Release Malicious'],
			'impersonation check': [true, false]
		};

		if (this.planInfo.threat_protection?.allow_billable_mailboxes) {
			filters['billable mailbox'] = [true, false];
		}

        this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.mailboxes,
            filters: filters,
			initFiltersFunction: this.initFilters,
        };
    };

	goToPlanSettingsPage = () => {
		this.router.navigate([this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.plan, this.dic.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration]);
    };

    getGroups =  (show) => {
        this.showGroups = show;
    };

    getMailboxesAliases =  (show) => {
        this.showAliases = show;
    };

	toggleNotificationDailyHour = (listOfHours, targetHour) => {
		if (listOfHours.includes(targetHour)) {
			_.remove(listOfHours, hour => hour === targetHour);
		}
		else {
			listOfHours.push(targetHour);
		}
	}

	toggleExpandItem = (item, event) => {
		if (!item.mailboxes?.length) {
			return;
		}

		item.isExpanded = !item.isExpanded;
		event.stopPropagation();
		this.doNotChangeIsExpandedStates = true;
	}

	updateListView = (listView) => {
		this.mailboxListView = listView;
		switch (listView) {
			case this.dic.CONSTANTS.userMgmntListViews.all:
				this.activeMailboxList = this.subscriptionUsers;
				break;

			case this.dic.CONSTANTS.userMgmntListViews.domains:
				this.activeMailboxList = this.createPerDomainList();
				break;
		}
	};

	createPerDomainList = () => {
		const domainsList = [];
		const domainGroups = _.groupBy(this.subscriptionUsers, mailbox => {
			mailbox.isSelectable = true;
			return mailbox.email.substring(mailbox.email.lastIndexOf('@') + 1)
		});

		_.each(domainGroups, (domainUsers, domainName) => {
			domainsList.push({
				domainName,
				isDomainTitleRecord: true,
				isSelectable: false,
				hideActions: true,
				mailboxes: domainUsers
			});
		});

		return domainsList;
	};

	searchMailboxExecute = (mailboxOrDomain, searchTerm, activeFilters) => {
		if (searchTextExecute(mailboxOrDomain, searchTerm)) {
			if (!activeFilters || this.searchFilterExecute(mailboxOrDomain, activeFilters)) {
				showAllSubMailboxes(mailboxOrDomain);
				if (!this.doNotChangeIsExpandedStates) {
					mailboxOrDomain.isExpanded = false;
				}

				return true;
			}
		}

		let isFound = false;
		if (mailboxOrDomain.mailboxes?.length) {
			for (let i = 0; i < mailboxOrDomain.mailboxes.length; i++) {
				const isSubUserFound = this.searchMailboxExecute(mailboxOrDomain.mailboxes[i], searchTerm, activeFilters);
				mailboxOrDomain.mailboxes[i].hide = !isSubUserFound;
				if (isSubUserFound) {
					isFound = true;
					if (!this.doNotChangeIsExpandedStates) {
						mailboxOrDomain.isExpanded = searchTerm || activeFilters;
					}
				}
			}
		}

		return isFound;
	}

	searchFilterExecute = (mailbox, filters) => {
		// need to match all filter types
		let numFilterToMatch = Object.keys(filters).length;

		if (filters.status?.length && filters.status.includes(mailbox.status)) {
			numFilterToMatch--;
		}
		if (filters['email relay']?.length && filters['email relay'].includes(mailbox.is_fes)) {
			numFilterToMatch--;
		}
		if (filters['executives']?.length && filters['executives'].includes(mailbox.is_executive)) {
			numFilterToMatch--;
		}
		if (filters['billable mailbox']?.length && filters['billable mailbox'].includes(mailbox.billable)) {
			numFilterToMatch--;
		}
		if (filters['impersonation check']?.length && filters['impersonation check'].includes(mailbox.check_impersonation)) {
			numFilterToMatch--;
		}
		if (filters['personal reviewer']?.length) {
			if (filters['personal reviewer'].includes('Allow Release Malicious') && mailbox.reviewer_allow_release_malicious) {
				numFilterToMatch--;
			}
			else if (filters['personal reviewer'].includes(mailbox.is_personal_reviewer)) {
				numFilterToMatch--;
			}
		}
		if (filters.license?.length && filters.license.includes(mailbox.license)) {
			numFilterToMatch--;
		}

		return !numFilterToMatch;
	}
}

// when parent record is found by search and/or filter, remove hide flag from it's children recursively
function showAllSubMailboxes(mailboxOrDomain) {
	if (mailboxOrDomain.mailboxes?.length) {
		mailboxOrDomain.mailboxes.forEach(subMailbox => {
			subMailbox.hide = false;
			showAllSubMailboxes(subMailbox);
		});
	}
}

function searchTextExecute(user, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((user.name && user.name.toLowerCase().indexOf(searchTerm) > -1) ||
		(user.job_title && user.job_title.toLowerCase().indexOf(searchTerm) > -1) ||
		(user.email && user.email.toLowerCase().indexOf(searchTerm) > -1));
}
